var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "nav-main",
      class: [_vm.isScroll || _vm.feedNav || _vm.top_bg ? "isScroll" : ""]
    },
    [
      _c("div", { staticClass: "top_nav" }, [
        _c(
          "div",
          { staticClass: "logo" },
          [
            _c(
              "router-link",
              { staticClass: "logoInfo", attrs: { to: "/", tag: "div" } },
              [_c("img", { attrs: { src: _vm.logoNameFun(), alt: "" } })]
            ),
            _vm._v(" "),
            !_vm.feedNav && !_vm.isdemandgiving
              ? _c(
                  "div",
                  { staticClass: "navList" },
                  [_c("top_menv", { staticClass: "nav-menu" })],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.feedNav && !_vm.isdemandgiving
              ? _c(
                  "div",
                  {
                    staticClass: "navList navList1",
                    staticStyle: { display: "flex", "align-items": "center" }
                  },
                  [
                    _c(
                      "el-popover",
                      {
                        attrs: {
                          placement: "bottom",
                          title: "",
                          width: "790",
                          trigger: "hover",
                          "visible-arrow": false
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "pop-deigo" },
                          [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-breadcrumb",
                                  {
                                    staticClass: "breadcrumb-style",
                                    attrs: {
                                      "separator-class": "el-icon-arrow-right"
                                    }
                                  },
                                  _vm._l(_vm.breadcrumbData, function(item) {
                                    return _c(
                                      "el-breadcrumb-item",
                                      {
                                        key: item,
                                        staticClass: "breadcrumb-item",
                                        nativeOn: {
                                          click: function($event) {
                                            return _vm.breadcrumbBtn(item)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "base-style" },
                                          [_vm._v(_vm._s(item))]
                                        )
                                      ]
                                    )
                                  }),
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "city-style" },
                                  _vm._l(
                                    _vm.procinceCity[_vm.currentCity],
                                    function(city) {
                                      return _c(
                                        "div",
                                        {
                                          key: city,
                                          staticClass: "item-style",
                                          on: {
                                            click: function($event) {
                                              return _vm.cityBtn(city)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(city) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("el-divider"),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c(
                                  "el-breadcrumb",
                                  {
                                    staticClass: "breadcrumb-style",
                                    attrs: {
                                      "separator-class": "el-icon-arrow-right"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-breadcrumb-item",
                                      { staticClass: "breadcrumb-item" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "base-style" },
                                          [_vm._v("市县专区")]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "city-style" },
                                  _vm._l(_vm.stageCity, function(stageitem) {
                                    return _c(
                                      "div",
                                      {
                                        key: stageitem.name,
                                        staticClass: "item-style",
                                        staticStyle: {
                                          width: "28%",
                                          "text-align": "center",
                                          padding: "4px 8px"
                                        },
                                        attrs: { title: stageitem.name },
                                        on: {
                                          click: function($event) {
                                            return _vm.stageBtn(stageitem)
                                          }
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticStyle: {
                                            width: "100%",
                                            height: "35px"
                                          },
                                          attrs: { src: stageitem.img, alt: "" }
                                        })
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "butn-hover",
                            attrs: { slot: "reference" },
                            slot: "reference"
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center"
                                }
                              },
                              [
                                _c("img", {
                                  staticStyle: {
                                    width: "23px",
                                    height: "23px",
                                    "border-radius": "2px"
                                  },
                                  attrs: {
                                    src: require("../../assets/images/area3.png")
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "province-style" }, [
                                  _vm._v(_vm._s(_vm.currentCity))
                                ]),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass: "el-icon-arrow-down",
                                  staticStyle: { color: "#22222e" }
                                })
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-popover",
                      {
                        attrs: {
                          placement: "bottom",
                          title: "",
                          width: "790",
                          trigger: "hover",
                          "visible-arrow": false
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "pop-deigo" },
                          [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-breadcrumb",
                                  {
                                    staticClass: "breadcrumb-style",
                                    attrs: {
                                      "separator-class": "el-icon-arrow-right"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-breadcrumb-item",
                                      { staticClass: "breadcrumb-item" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "base-style" },
                                          [_vm._v("产业平台")]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "city-style" },
                                  _vm._l(_vm.produceStage, function(stageitem) {
                                    return _c(
                                      "div",
                                      {
                                        key: stageitem.name,
                                        staticClass: "item-style",
                                        staticStyle: { "text-align": "center" },
                                        style: {
                                          width: stageitem.w ? "20%" : "30%"
                                        },
                                        attrs: { title: stageitem.name },
                                        on: {
                                          click: function($event) {
                                            return _vm.stageBtn(stageitem)
                                          }
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticStyle: { height: "40px" },
                                          style: {
                                            width: stageitem.w
                                              ? "145px"
                                              : "100%"
                                          },
                                          attrs: { src: stageitem.img, alt: "" }
                                        })
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("el-divider"),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c(
                                  "el-breadcrumb",
                                  {
                                    staticClass: "breadcrumb-style",
                                    attrs: {
                                      "separator-class": "el-icon-arrow-right"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-breadcrumb-item",
                                      { staticClass: "breadcrumb-item" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "base-style" },
                                          [_vm._v("金融服务平台")]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "city-style" },
                                  _vm._l(_vm.moenyStage, function(stageitem) {
                                    return _c(
                                      "div",
                                      {
                                        key: stageitem.name,
                                        staticClass: "item-style",
                                        staticStyle: {
                                          width: "20%",
                                          "text-align": "center"
                                        },
                                        attrs: { title: stageitem.name },
                                        on: {
                                          click: function($event) {
                                            return _vm.stageBtn(stageitem)
                                          }
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticStyle: {
                                            width: "145px",
                                            height: "40px"
                                          },
                                          attrs: { src: stageitem.img, alt: "" }
                                        })
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "butn-hover",
                            attrs: { slot: "reference" },
                            slot: "reference"
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center"
                                }
                              },
                              [
                                _c("img", {
                                  staticStyle: {
                                    "margin-left": "15px",
                                    width: "20px",
                                    height: "20px",
                                    "border-radius": "2px"
                                  },
                                  attrs: {
                                    src: require("../../assets/images/home.png")
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "province-style" }, [
                                  _vm._v("供应链平台体系")
                                ]),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass: "el-icon-arrow-down",
                                  staticStyle: { color: "#22222e" }
                                })
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-popover",
                      {
                        ref: "popoverRef",
                        attrs: {
                          placement: "bottom",
                          title: "",
                          width: "790",
                          trigger: "hover",
                          "visible-arrow": false
                        }
                      },
                      [
                        _c("div", { staticClass: "pop-deigo" }, [
                          _c(
                            "div",
                            [
                              _c("img", {
                                staticStyle: {
                                  width: "91%",
                                  "margin-bottom": "20px",
                                  cursor: "pointer"
                                },
                                attrs: {
                                  src: require("../../assets/images/home/ediTitleImg.png")
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.clickediDover()
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "el-breadcrumb",
                                {
                                  staticClass: "breadcrumb-styleOne",
                                  attrs: {
                                    "separator-class": "el-icon-arrow-right"
                                  }
                                },
                                [
                                  _c(
                                    "el-breadcrumb-item",
                                    { staticClass: "breadcrumb-item" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "base-style" },
                                        [_vm._v("阳逻港区")]
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "city-styleyangluogang" },
                                _vm._l(_vm.yangluogangStage, function(
                                  stageitem
                                ) {
                                  return _c(
                                    "div",
                                    {
                                      key: stageitem.name,
                                      staticClass: "item-styleyangluogang",
                                      attrs: { title: stageitem.name },
                                      on: {
                                        click: function($event) {
                                          return _vm.yangluogangbtn(
                                            stageitem.url
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "item-styleOne" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "item-styleOne" },
                                            [
                                              _c("img", {
                                                staticStyle: {
                                                  height: "50px",
                                                  "margin-right": "10px"
                                                },
                                                style: {
                                                  width: stageitem.w
                                                    ? "50px"
                                                    : "50px"
                                                },
                                                attrs: {
                                                  src: stageitem.img,
                                                  alt: ""
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "item-styleTwo"
                                                },
                                                [
                                                  _c("div", [
                                                    _vm._v(
                                                      _vm._s(stageitem.name)
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("div", [
                                                    _vm._v(
                                                      _vm._s(stageitem.text)
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c(
                                "el-breadcrumb",
                                {
                                  staticClass: "breadcrumb-styleOne",
                                  attrs: {
                                    "separator-class": "el-icon-arrow-right"
                                  }
                                },
                                [
                                  _c(
                                    "el-breadcrumb-item",
                                    { staticClass: "breadcrumb-item" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "base-style" },
                                        [_vm._v("经开港区")]
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.wuhanPortZone
                                ? _c(
                                    "div",
                                    { staticClass: "city-styleyangluogang" },
                                    _vm._l(_vm.jingkaiStage, function(
                                      stageitem
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: stageitem.name,
                                          staticClass: "item-styleyangluogang",
                                          attrs: { title: stageitem.name },
                                          on: {
                                            click: function($event) {
                                              return _vm.yangluogangbtn(
                                                stageitem.url
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "item-styleOne" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "item-styleOne"
                                                },
                                                [
                                                  _c("img", {
                                                    staticStyle: {
                                                      height: "50px",
                                                      "margin-right": "10px"
                                                    },
                                                    style: {
                                                      width: stageitem.w
                                                        ? "50px"
                                                        : "50px"
                                                    },
                                                    attrs: {
                                                      src: stageitem.img,
                                                      alt: ""
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "item-styleTwo"
                                                    },
                                                    [
                                                      _c("div", [
                                                        _vm._v(
                                                          _vm._s(stageitem.name)
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("div", [
                                                        _vm._v(
                                                          _vm._s(stageitem.text)
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ]
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "rightCon" }, [
          _vm.key !== "/index"
            ? _c(
                "div",
                { staticClass: "elt" },
                [
                  _c(
                    "router-link",
                    { staticClass: "img-title", attrs: { to: "/", tag: "a" } },
                    [
                      _c("img", {
                        staticClass: "home-img",
                        attrs: {
                          src: require("@/assets/icon/home.png"),
                          alt: ""
                        }
                      }),
                      _vm._v("\n          主页\n        ")
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "loginBox" },
            [
              _vm.userInfo.name || _vm.userInfo.phone
                ? [
                    _c(
                      "div",
                      {
                        staticClass: "userInfo",
                        class: _vm.key != "/index" ? "userInfoBefore" : ""
                      },
                      [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              "popper-class": "atooltip",
                              content: _vm.userInfo.name || "手机用户",
                              placement: "bottom",
                              effect: "light"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "name",
                                on: { click: _vm.jumpUserCenter }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.userInfo.name || "手机用户") +
                                    "\n              "
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "logOut", on: { click: _vm.logOut } },
                          [_vm._v("登出")]
                        )
                      ],
                      1
                    )
                  ]
                : [
                    _c(
                      "div",
                      { staticClass: "login", on: { click: _vm.loginFn } },
                      [_vm._v("登录")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "logon", on: { click: _vm.register } },
                      [_vm._v("注册")]
                    )
                  ]
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _vm.feedNav && !_vm.isdemandgiving
        ? _c("div", { staticClass: "second_nav" }, [_c("top_menv")], 1)
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "理货网上查询系统",
            visible: _vm.dialogVisible,
            width: "25%",
            center: "",
            "z-index": "9999999999999999999999999999999999999999999999",
            "modal-append-to-body": true
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("img", {
            staticStyle: { width: "100%" },
            attrs: {
              src: require("../../assets/images/zhonglitankuang.png"),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("span", {
            staticClass: "dialog-footer",
            attrs: { slot: "footer" },
            slot: "footer"
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "dialogStyle",
          attrs: {
            visible: _vm.dialogVisibleOne,
            width: "35%",
            "z-index": "9999999999999999999999999999999999999999999999",
            "modal-append-to-body": true
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisibleOne = $event
            }
          }
        },
        [
          _c("img", {
            attrs: {
              src: require("../../assets/images/eidDetails.png"),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("span", {
            staticStyle: { display: "none" },
            attrs: { slot: "footer" },
            slot: "footer"
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-392a26c8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-392a26c8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/top_nav/index.vue
// module id = null
// module chunks = 